/*
 * AI 生成内容告知。
 *
 * 对话现场必须持续展示显著标识，设置页同时保留完整说明。角色在剧情里是否
 * 承认自己是 AI，不得影响产品界面的合规告知。
 */

/** 模型回复底部唯一的一处 AI 生成标识。 */
export function AiGeneratedMark() {
  return (
    <div
      className="ai-generated-mark"
      role="note"
      aria-label="AI 生成内容提示"
    >
      AI生成内容
    </div>
  );
}

export function AiDisclosureSection() {
  return (
    <div className="prose">
      <p>
        缈缈说的话由人工智能模型生成，<strong>不是真人回复</strong>。
      </p>
      <p>
        她可能会记错、说错，或者在灵力不足时反应变慢。涉及医疗、法律、
        财务的实质决策，以及任何紧急情况，请不要把她的话当作依据。
      </p>
    </div>
  );
}
